import React, { Fragment, useState, useContext, useEffect } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { APIContext } from '../contexts/APIContext';
import { getUserEnterpriseId, getUserIdFromLocalStorage, addDoubleApostrophe, getValidToken } from '../utils';
import { useMsal } from '@azure/msal-react';
import { useToast } from './ui/toast/UseToast';
export const Usersurvey = (props: any) => {
  const {
    surveyOptions,
    clientData = [],
    websocketConnectionRef: { current: websocket },
  } = useContext(APIContext);
  const { openUserSurvey, setOpenUserSurvey } = props;
  const [selectedPurpose, setSelectedPurpose] = useState('');
  const [searchText, setSearchText] = useState('');
  const [filteredOptions, setFilteredOptions] = useState<string[]>([]);
  const [timeSaved, setTimeSaved] = useState<number | string>('');
  const [errorMessage, setErrorMessage] = useState<string>('');
  const surveyOption = surveyOptions || [];
  const { accounts } = useMsal();
  const options = Array.isArray(clientData) ? clientData.map((client) => client.Name) : [];
  const { toast } = useToast();

  const handlePurposeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedPurpose(event.target.value);
    setSearchText('');
    setTimeSaved('');
    setFilteredOptions(options);
  };

  const handleSelectChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchText(value);
    setFilteredOptions(options.filter((option) => option.toLowerCase().includes(value.toLowerCase())));
  };

  const handleOptionClick = (option: string) => {
    setSearchText(option);
    setFilteredOptions([]);
  };

  // const handleTimeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const newValue = e.target.value;
  //   if (/^\d*$/.test(newValue)) {
  //     // Allows only digits and allows max 43200
  //     const numericValue = Number(newValue);
  //     numericValue > 43200 ? setErrorMessage('Exceeding maximum limit') : setErrorMessage('');
  //     setTimeSaved(newValue);
  //   }
  // };

  // useEffect(() => {
  //   if (timeSaved === '') {
  //     setErrorMessage('');
  //   }
  // }, [timeSaved]);

  // const getSurveyOptionId = (index: number) => {
  //   if (surveyOption.length) {
  //     return surveyOption[index][0];
  //   }
  // };

  // const isSubmitEnabled = () => {
  //   if (errorMessage) return false;
  //   if (selectedPurpose === getSurveyOptionId(0) || selectedPurpose === getSurveyOptionId(1)) {
  //     return options.includes(searchText) && timeSaved !== '';
  //   }
  //   if (selectedPurpose === getSurveyOptionId(2)) {
  //     return searchText.trim() === '' || options.includes(searchText); // Ensure that the custom text is empty or valid client option
  //   }
  //   return false;
  // };

  const handleSubmit = async () => {
    const token = await getValidToken();
    setOpenUserSurvey(false);
    const selectedClient = clientData.find((client) => client.Name === searchText);
    const payload = {
      function: 'save_surveytracking',
      userId: getUserIdFromLocalStorage(),
      EnterpriseId: getUserEnterpriseId(accounts),
      GMAUsageObjectiveUId: selectedPurpose,
      ClientId: selectedClient ? selectedClient.Id : null,
      ClientName: selectedClient && searchText ? addDoubleApostrophe(searchText) : null,
      Market: selectedClient ? selectedClient.Market : null,
      MarketUnit: selectedClient ? selectedClient.MarketUnit : null,
      IndustrySegment: selectedClient ? selectedClient.IndustrySegment : null,
      DominantIndustryTxt: selectedClient ? selectedClient.DominantIndustryTxt : null,
      UsageInMins: timeSaved ? timeSaved : null,
      authorization: `Bearer ${token}`,
    };
    console.log('payload for request save surveytool: ', payload);
    websocket?.send('SendMessage', payload);
    toast({
      status: 'success',
      description: 'Survey submitted successfully!',
    });
  };

  return (
    <>
      <Transition.Root show={openUserSurvey} as={Fragment}>
        <Dialog as="div" className="relative z-[100]" onClose={() => setOpenUserSurvey(true)}>
          {/* Opaque overlay */}
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-30 transition-opacity" />
          </Transition.Child>

          {/* Modal panel */}
          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4"
                enterTo="opacity-100 translate-y-0"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0"
                leaveTo="opacity-0 translate-y-4"
              >
                <div className="flex flex-col items-center flex-shrink-0 w-fit lg:w-1/2 mx-auto px-4 tablet:px-8">
                  <Dialog.Panel className="relative flex border-t-4 border-t-[#A100FF] max-w-[582px] h-auto tablet:h-[392px] transform flex-col bg-gamma-modal-bg font-graphik text-black transition-all">
                    <div className="relative flex transform flex-col bg-[var(--Surface-card-bg, #FFF)] shadow-md px-4 pt-[18px] tablet:pr-[60px] tablet:pl-[40px] pb-[40px] gap-2">
                      <Dialog.Title className="text-black font-graphik text-[20px] tablet:text-[28px] font-medium tablet:font-normal leading-[28px] pb-4">
                        GMA Assistant Usage
                      </Dialog.Title>
                      <Dialog.Description className="text-black font-graphik text-[14px] font-normal leading-[20px] pb-4">
                        Hi! Please take 10 seconds to let us know on you&apos;re using Generative Market Analysis this
                        month. Thanks for helping us track usage!
                      </Dialog.Description>
                      <Dialog.Description className="text-black font-graphik text-[14px] font-normal leading-[20px]">
                        Select purpose of leveraging GMA Assistant
                      </Dialog.Description>
                      <div className="flex flex-col tablet:flex-row items-start gap-4 tablet:gap-8">
                        {surveyOption.map(([id, label]: [string, string], index: number) => (
                          <div key={id} className="flex items-center gap-2">
                            <input
                              name="purpose"
                              type="radio"
                              value={id}
                              className="w-5 h-5 accent-purple-600 cursor-pointer focus:outline-none"
                              onChange={handlePurposeChange}
                            />
                            <label className="text-sm cursor-default select-none">{label}</label>
                          </div>
                        ))}
                      </div>
                      <>
                        <Dialog.Description className="text-black font-graphik text-[14px] font-normal leading-[20px] pt-4">
                          Client or Project Code Name
                          {/* {(selectedPurpose === getSurveyOptionId(0) || selectedPurpose === getSurveyOptionId(1)) && (
                            <span className="text-red-600">*</span>
                          )} */}
                        </Dialog.Description>
                        <div className="relative inline-block">
                          <input
                            type="text"
                            value={searchText}
                            onChange={handleSelectChange}
                            className="w-full h-[38px] text-gray-700 border border-[#ccc] p-2 text-xs tablet:text-sm"
                            placeholder="Search for Client or Project Code Name"
                          />
                          {searchText && filteredOptions.length > 0 && (
                            <div className="absolute z-10 w-full bg-white border border-[#ccc] max-h-48 Scrollbar">
                              {filteredOptions.map((option, index) => (
                                <div
                                  key={index}
                                  className="cursor-pointer p-2 hover:bg-[#F5F5F5] hover:text-[#7500C0] text-sm"
                                  onClick={() => handleOptionClick(option)}
                                >
                                  {option}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </>

                      {/* <Dialog.Description className="text-black font-graphik text-[14px] font-normal leading-[20px]">
                        How much time (in minutes) have you saved using our Growth.AI toolkit versus if it were not
                        available at all?
                        {(selectedPurpose === getSurveyOptionId(0) || selectedPurpose === getSurveyOptionId(1)) && (
                          <span className="text-red-600">*</span>
                        )}
                      </Dialog.Description> */}

                      {/* <input
                        type="text"
                        className="mt-2 h-[48px] text-gray-700 border border-[#ccc] p-2 text-sm"
                        placeholder="Please enter time saved in a day(max 43200 minutes)"
                        value={timeSaved}
                        onChange={handleTimeChange}
                      />
                      {errorMessage && <p className="fixed mt-[22.5rem] text-red-500 text-xs">{errorMessage}</p>} */}
                    </div>

                    <div className="flex flex-row flex-nowrap justify-end gap-5 pr-[32px] py-[20px]">
                      <button
                        className={`rounded-sm px-4 py-2 h-[40px] w-[108px] text-white ${
                          selectedPurpose && (options.includes(searchText) || searchText.trim() === '')
                            ? 'bg-black hover:bg-[#460073]'
                            : 'bg-[#CCCCCC] not-clickable'
                        }`}
                        // disabled={selectedPurpose}
                        onClick={handleSubmit}
                      >
                        Submit
                      </button>
                    </div>
                  </Dialog.Panel>
                </div>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
};

export default Usersurvey;
